module.exports = __webpack_public_path__ + "img/market-place-white.5543680f.svg";